/// <reference types="vite/client" />

import { createClient } from '@supabase/supabase-js';
import type { Database } from '../../types/src/database-types';

const URL: string = (import.meta.env.VITE_SUPABASE_URL as string) || '';
const PUBLISHABLE_KEY: string =
  (import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY as string) || '';
const APP_SLUG: string = (import.meta.env.VITE_APP_SLUG as string) || '';
const appSlug = APP_SLUG.toLowerCase();

if (!URL || !PUBLISHABLE_KEY) {
  throw new Error(
    'Supabase URL or Anon Key is not defined in environment variables',
  );
}

// Create a singleton Supabase client with database types
const supabase = createClient<Database>(String(URL), String(PUBLISHABLE_KEY), {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    storage: localStorage,
    storageKey: appSlug,
  },
  global: { headers: { 'x-client-info': appSlug } },
});

export { supabase };

// Type exports for convenience
export type Tables<T extends keyof Database['public']['Tables']> =
  Database['public']['Tables'][T]['Row'];
export type Insertable<T extends keyof Database['public']['Tables']> =
  Database['public']['Tables'][T]['Insert'];
export type Updatable<T extends keyof Database['public']['Tables']> =
  Database['public']['Tables'][T]['Update'];

// Then, in any component or module where you need Supabase: // import { supabase } from '../utils/supabaseClient'; // const { data, error } = await supabase.from('your_table').select('*');
